export const Marquee = ({ items, dark = false }) => (
  <div
    data-testid="editorial-marquee"
    className={`overflow-hidden border-y ${
      dark
        ? "border-neutral-800 bg-[#141414] text-neutral-200"
        : "border-neutral-200 bg-[#f8f9fa] text-neutral-700"
    }`}
  >
    <div className="marquee-track flex w-max whitespace-nowrap py-5 md:py-7">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
          {items.map((item, i) => (
            <span
              key={`${copy}-${i}`}
              className="mx-8 flex items-center gap-16 font-overline text-[11px] uppercase tracking-[0.35em] md:mx-12 md:text-sm"
            >
              {item}
              <span className="inline-block h-1.5 w-1.5 rotate-45 bg-[#e63946]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
